/** @typedef {import('@mantine/core').MantineThemeOverride} MantineThemeOverride */
/** @typedef {NonNullable<MantineThemeOverride['components']>['MultiSelect']} MultiSelectTheme */

import { ErrorStyles } from 'theme/components/Inputs/shared/Error';
import fullTextSearch from 'utils/full-text-search';

/** @type {MultiSelectTheme} */
export const MultiSelect = {
  defaultProps: {
    /**
     * Filter function applied when using searchable prop.
     *
     * @param {string} search
     * @param {boolean} selected
     * @param {{ label: string }} item
     */
    filter: (search, selected, item) => {
      if (selected) {
        return false;
      }

      return fullTextSearch(search, item.label);
    },
  },
  styles: {
    item: {
      color: '#4D4D4D',
      fontSize: '15px',
      lineHeight: '20px',
    },
    error: ErrorStyles,
  },
};
